import React, { useState, useEffect } from 'react';
import { FaThLarge, FaList, FaStar, FaRegStar } from "react-icons/fa";
import { useNavigate } from "react-router-dom";
import { Button } from "react-bootstrap";

import SearchInput from "../../Atoms/SearchInput";
import Loader from '../../Atoms/Loader';
import ClientFilterDropdown from "./Atoms/ClientFilterDropdown";
import OrderByDropdown from "./Atoms/OrderByDropdown";

import CardProject from './Molecules/CardProject';

const ProjectsTemplate = ({ projects, clients, loadingProjects, deleteFunction, favoriteFunction }) => {
    const navigate = useNavigate();

    const [view, setView] = useState('grid');
    const [projectsList, setProjectsList] = useState(projects);
    const [favoriteFilter, setFavoriteFilter] = useState(false);
    const [searchFilter, setSearchFilter] = useState("");
    const [filterByClient, setFilterByClient] = useState("");
    const [orderBy, setOrderBy] = useState("");

    useEffect(() => {
        let filtered = [...projects];

        if (searchFilter !== "") {
            filtered = filtered.filter(project => project.name.toLowerCase().includes(searchFilter.toLowerCase()));
        }
        if (filterByClient !== "") {
            filtered = filtered.filter(project => project.client === filterByClient.name);
        }
        if (favoriteFilter) {
            filtered = filtered.filter(project => project.favorite === true);
        }

        switch (orderBy) {
            case "alphabetical":
                filtered = filtered.sort((a, b) => a.name.localeCompare(b.name));
                break;
            case "lastCreated":
                filtered = filtered.sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt));
                break;
            case "lastOpened":
            case "lastModified":
                filtered = filtered.sort((a, b) => {
                    const dateA = a.last_user_updated?.date ? new Date(a.last_user_updated.date) : new Date(0);
                    const dateB = b.last_user_updated?.date ? new Date(b.last_user_updated.date) : new Date(0);
                    return dateB - dateA;
                });
                break;
            default:
                break;
        }

        setProjectsList(filtered);
    }, [projects, searchFilter, filterByClient, favoriteFilter, orderBy]);

    const handleLabel = (project) => {
        const lastUserToUpdate = project.last_user_updated.user;
        const lastUpdateDate = new Date(project.last_user_updated.date);
        const now = new Date();
        const diffMs = now - lastUpdateDate;
        const diffMins = Math.floor(diffMs / (1000 * 60));
        const diffHours = Math.floor(diffMs / (1000 * 60 * 60));
        const diffDays = Math.floor(diffMs / (1000 * 60 * 60 * 24));
        const diffMonths = Math.floor(diffDays / 30);
        const diffYears = Math.floor(diffDays / 365);

        let timeAgo = '';
        if (diffMins < 60) {
            timeAgo = `${diffMins} minuto${diffMins !== 1 ? 's' : ''}`;
        } else if (diffHours < 24) {
            timeAgo = `${diffHours} hora${diffHours !== 1 ? 's' : ''}`;
        } else if (diffDays < 30) {
            timeAgo = `${diffDays} dia${diffDays !== 1 ? 's' : ''}`;
        } else if (diffMonths < 12) {
            timeAgo = `${diffMonths} ${diffMonths !== 1 ? 'meses' : 'mês'}`;
        } else {
            timeAgo = `${diffYears} ano${diffYears !== 1 ? 's' : ''}`;
        }

        return `Editado há ${timeAgo} atrás - por ${lastUserToUpdate} `;
    }

    return (
        <div className="container-xxl my-5">
            <div id="projects-header" className="row mb-5">
                <div className="col-6">
                    <h1>Projetos</h1>
                </div>

                <div className="col-6 text-end">
                    <Button
                        onClick={() => navigate('/new-project')}
                        style={{ backgroundColor: '#8E51FF', fontWeight: 'bold', padding: '10px 20px' }}
                    >
                        + novo projeto
                    </Button>
                </div>
            </div>

            <div id="projects-filters" className="row mb-5">
                <div className="container-fluid py-2">
                    <div className="d-flex flex-wrap gap-2 align-items-center justify-content-between">
                        
                        <SearchInput
                            value={searchFilter}
                            placeholder="Buscar projeto..."
                            onChange={e => setSearchFilter(e.target.value)}
                        />

                        <div className="d-flex flex-row justify-content-center align-items-center">
                            <p className="pe-2">Filtrar por: </p>
                            <ClientFilterDropdown
                                selectedClient={filterByClient}
                                style={{ minWidth: '100px' }}
                                clients={clients}
                                onSelect={(selectedClient) => {
                                    setFilterByClient(selectedClient);
                                }}
                            />
                        </div>

                        <div className="d-flex flex-row justify-content-center align-items-center">
                            <p className="pe-2">Ordenar por: </p>
                            <OrderByDropdown
                                style={{ minWidth: '100px' }}
                                selectedOrder={orderBy}
                                onSelect={(selectedOrderBy) => {
                                    setOrderBy(selectedOrderBy);
                                }}
                            />
                        </div>

                        <div className="d-flex align-items-center gap-2">
                            <Button
                                className='bg-transparent'
                                onClick={() => setFavoriteFilter(!favoriteFilter)}
                            >
                                {favoriteFilter ? <FaStar color='yellow' /> : <FaRegStar />}
                            </Button>

                            <div style={{ backgroundColor: view === 'grid' ? '#1D293D': 'inherit', borderRadius: 6 }}
                            >
                                <Button
                                    className='bg-transparent'
                                    onClick={() => setView('grid')}
                                >
                                    <FaThLarge color={view === 'grid' ? '8E51FF' : '#fff'} />
                                </Button>
                            </div>

                            <div style={{ backgroundColor: view === 'list' ? '#1D293D': 'inherit', borderRadius: 6 }}>
                                <Button
                                    className='bg-transparent'
                                    onClick={() => setView('list')}
                                >
                                    <FaList color={view === 'list' ? '8E51FF' : '#fff'} />
                                </Button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            {view === 'list' && projectsList.length !== 0 && (
                <div
                    className='d-flex justify-content-between flex-row p-4 rounded rounded-bottom-0'
                    style={{ backgroundColor: '#212529', width: '100%'}}
                >
                    
                        <div className='col-4'>Nome do projeto</div>
                        <div className='col-4'>Última edição</div>
                        <div className='col-4 mr-4'>
                            <p className='d-flex justify-content-end me-5'>Cliente</p>
                        </div>
                    
                </div>
            )}


            <div id="projects" className='row'>     
                {loadingProjects && (
                    <div className='d-flex flex-column align-items-center justify-content-center' style={{ height: '50vh'}}>
                        <Loader />
                    </div>
                )}

                {projectsList.length !== 0 && !loadingProjects && (
                    <>
                        {view === 'grid' ? (
                            projectsList.map((project, index) => (
                                <div key={index} className='col-12 col-md-4 mb-2'>
                                    <CardProject
                                        title={project.name}
                                        label={handleLabel(project)}
                                        clientName={project.client}
                                        thumbnail={project.thumbnail}
                                        isFavorite={project.favorite}
                                        accessFunction={() => navigate(`/project/${project.id}`)}
                                        favoriteFunction={() => favoriteFunction(project.id, project.favorite)}
                                        deleteFunction={() => deleteFunction(project.id)}
                                        view='card'
                                    />
                                </div>
                            ))
                        ) : (
                            <>
                                {projectsList.map((project, index) => (
                                    <div key={index} className='col-12 mb-2'>
                                        <CardProject
                                            title={project.name}
                                            label={handleLabel(project)}
                                            clientName={project.client}
                                            thumbnail={project.thumbnail}
                                            isFavorite={project.favorite}
                                            accessFunction={() => navigate(`/project/${project.id}`)}
                                            favoriteFunction={() => favoriteFunction(project.id, project.favorite)}
                                            deleteFunction={() => deleteFunction(project.id)}
                                            view='list'
                                        />
                                    </div>
                                ))}
                            </>
                        )}
                    </>
                )}

                {projectsList.length === 0 && !loadingProjects && (
                    <div className='d-flex flex-column align-items-center justify-content-center' style={{ height: '50vh'}}>
                        {favoriteFilter ? (
                            <p style={{ color: 'gray' }}>Você ainda não possui nenhum projeto favoritado</p>
                        ) : (
                            <>
                                <p style={{ color: 'gray' }}>Você ainda não possui vínculo com nenhum projeto</p>
                                <Button
                                    onClick={() => ( navigate('/new-project'))}
                                    style={{ backgroundColor: '#8E51FF', fontWeight: 'bold', padding: '10px 20px', marginTop: '1em' }}
                                >
                                    Criar novo projeto
                                </Button>
                            </>
                        )}
                    </div>
                )}
            </div>
        </div>
    );
};

export default ProjectsTemplate;